import React, { createContext, useContext, useState, useCallback } from 'react';

interface QuotaNotificationContextType {
  isBannerVisible: boolean;
  bannerMessage: string;
  showQuotaNotification: (message: string) => void;
  hideQuotaNotification: () => void;
}

const QuotaNotificationContext = createContext<QuotaNotificationContextType | undefined>(undefined);

export const QuotaNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const [bannerMessage, setBannerMessage] = useState('');

  const showQuotaNotification = useCallback((message: string) => {
    setBannerMessage(message);
    setIsBannerVisible(true);
  }, []);

  const hideQuotaNotification = useCallback(() => {
    setIsBannerVisible(false);
  }, []);

  return (
    <QuotaNotificationContext.Provider value={{ isBannerVisible, bannerMessage, showQuotaNotification, hideQuotaNotification }}>
      {children}
    </QuotaNotificationContext.Provider>
  );
};

export const useQuotaNotification = () => {
  const context = useContext(QuotaNotificationContext);
  if (context === undefined) {
    throw new Error('useQuotaNotification must be used within a QuotaNotificationProvider');
  }
  return context;
};
